package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * A compact row with a label, optional trailing detail, and an optional remove (✕) action.
 */
@Composable
fun ListRow(label: String, detail: String? = null, onRemove: (() -> Unit)? = null) {
    ListRow(detail = detail, onRemove = onRemove) { Text(label) }
}

/**
 * A [ListRow] whose label is custom [content], for labels that mix styles.
 */
@Composable
fun ListRow(detail: String? = null, onRemove: (() -> Unit)? = null, content: @Composable () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .gap(0.5.cssRem)
            .padding(topBottom = 0.4.cssRem, leftRight = 0.75.cssRem)
            .borderRadius(4.px)
            .backgroundColor(AppColors.subtleSurface),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Span { content() }
        detail?.let { Span(Modifier.color(AppColors.muted).toAttrs()) { Text(it) } }
        if (onRemove != null) {
            Span(Modifier.cursor(Cursor.Pointer).color(AppColors.muted).onClick { onRemove() }.toAttrs()) {
                Text("✕")
            }
        }
    }
}

@Composable
fun ErrorText(message: String) {
    P(Modifier.color(AppColors.danger).toAttrs()) { Text(message) }
}
